(function () {
var tries = 0;
function init() {
var M = window.MK3;
if (!M) { if (++tries < 200) setTimeout(init, 150); return; }
var T = M.T, st = M.stage, cv = st.querySelector('canvas'), ray = new T.Raycaster(), ms = new T.Vector2(), sel = null, hov = null;
var card = document.querySelector('[data-m3-card]'), find = document.querySelector('[data-m3-find]'), dl = document.getElementById('m3-dl'), list = document.querySelector('[data-m3-top]');
function hit(e) {
var b = cv.getBoundingClientRect();
ms.x = ((e.clientX - b.left) / b.width) * 2 - 1; ms.y = -((e.clientY - b.top) / b.height) * 2 + 1;
ray.setFromCamera(ms, M.cam);
var h = ray.intersectObjects(M.objs(), false)[0];
return h ? h.object : null;
}
function glow(m, on) { if (m) m.material.emissiveIntensity = on ? 2.4 : 0.6; }
function info(m) {
var o = m.userData.o, C = M.cur(), y = M.yr(), r = M.raw(o, y), v = M.val(o, y), lb = M.lb();
var arr = M.objs().map(function (x) { return [x, M.val(x.userData.o, y)]; }).filter(function (a) { return a[1] != null; }).sort(function (a, b) { return b[1] - a[1]; });
var rk = 0; arr.forEach(function (a, i) { if (a[0] === m) rk = i + 1; });
var s = '<b>' + M.esc(o.n) + '</b>';
if (r == null) s += '<span>Not reported for ' + y + '</span>';
else if (C.rate) s += '<span>' + M.f(v) + ' ' + lb + ' per 100,000 people in ' + y + '</span>';
else s += '<span>' + M.f(r) + ' ' + lb + ' in ' + y + '</span>' + (C.per ? '<span>' + M.f(v, 1) + ' per 1,000 residents</span>' : '');
if (rk) s += '<span>' + (rk === 1 ? 'Highest' : 'Number ' + rk) + ' of ' + arr.length + ' this year</span>';
return s;
}
function where(m) { var b = new T.Box3().setFromObject(m), p = new T.Vector3(); b.getCenter(p); return p; }
function fly(m) {
if (M.stopIntro) M.stopIntro();
var from = M.controls.target.clone(), to = where(m), offA = M.cam.position.clone().sub(from), offB = offA.clone().setLength(Math.max(260, Math.min(offA.length(), 520))), t0 = performance.now();
(function step(now) {
var k = Math.min(1, (now - t0) / 900), e = 1 - Math.pow(1 - k, 3);
M.controls.target.lerpVectors(from, to, e);
M.cam.position.copy(M.controls.target).add(offA.clone().lerp(offB, e));
M.kick();
if (k < 1) requestAnimationFrame(step);
})(t0);
}
function fill(m) { card.innerHTML = info(m) + '<button type="button" aria-label="Close">&times;</button>'; card.querySelector('button').onclick = function () { select(null); }; }
function select(m, go) {
glow(sel, false); sel = m;
if (!m) { card.hidden = true; return; }
glow(m, true); fill(m); card.hidden = false;
if (go) fly(m);
}
function byName(n) {
n = String(n).trim().toLowerCase(); var hitM = null;
M.objs().forEach(function (x) { var a = x.userData.o.n.toLowerCase(); if (!hitM && (a === n || a.replace(/, [a-z]{2}$/, '') === n)) hitM = x; });
if (!hitM) M.objs().forEach(function (x) { if (!hitM && x.userData.o.n.toLowerCase().indexOf(n) === 0) hitM = x; });
return hitM;
}
var down = null;
cv.addEventListener('pointerdown', function (e) { down = [e.clientX, e.clientY]; });
cv.addEventListener('pointerup', function (e) {
if (!down || Math.abs(e.clientX - down[0]) + Math.abs(e.clientY - down[1]) > 8) { down = null; return; }
down = null; var m = hit(e); select(m, !!m);
});
cv.addEventListener('pointermove', function (e) {
if (e.pointerType !== 'mouse') return;
var m = hit(e);
if (hov && hov !== m && hov !== sel) glow(hov, false);
hov = m;
if (!m) { M.tip.hidden = true; cv.style.cursor = 'grab'; return; }
if (m !== sel) m.material.emissiveIntensity = 1.6;
cv.style.cursor = 'pointer';
var b = cv.getBoundingClientRect();
M.tip.hidden = false; M.tip.innerHTML = info(m);
M.tip.style.left = Math.min(b.width - 250, e.clientX - b.left + 14) + 'px'; M.tip.style.top = (e.clientY - b.top + 14) + 'px';
});
cv.addEventListener('pointerleave', function () { M.tip.hidden = true; if (hov && hov !== sel) glow(hov, false); hov = null; });
if (find) find.addEventListener('change', function () { var m = byName(find.value); if (m) { select(m, true); find.blur(); } });
if (list) list.addEventListener('click', function (e) {
var li = e.target.closest('li'); if (!li) return;
var m = byName(li.querySelector('span').textContent.replace(/^\d+\.\s*/, '')); if (m) select(m, true);
});
M.onBuild = function () {
select(null); M.controls.target.set(0, 0, 0);
if (find) find.value = '';
if (dl) dl.innerHTML = M.objs().map(function (x) { return '<option value="' + M.esc(x.userData.o.n) + '">'; }).join('');
};
M.onApply = function () { if (sel) { glow(sel, true); fill(sel); } };
if (M.objs().length) M.onBuild();
}
init();
})();